import { H1, H2, P1 } from '../../../styles/FontStyles';
import {
  Main,
  Section1Image2,
  Section4Title,
  Section4Wrapper,
  Section4Wrapper2,
} from '../Home.styled';

import image from '../../../assets/images/section4Image.png';
import imageMobile from '../../../assets/images/section4ImageMobile.png';
import { colors, lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';

import img1 from '../../../assets/images/sec4img1.png';
import img2 from '../../../assets/images/sec4img2.png';
import img3 from '../../../assets/images/sec4img3.png';
import img4 from '../../../assets/images/sec4img4.png';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';

const slides = [
  {
    title: 'AI-Driven Personalization',
    text: 'The platform uses artificial intelligence to deliver tailored travel recommendations, ensuring each aspect of the journey aligns with the user’s preferences, budget, and travel style.',
    image: img1,
  },
  {
    title: 'Tailored for you',
    text: 'TOP 10 recommendations for the day that might interest you! Restaurants, Attractions with tickets to purchase, Events that are happening in the city right now, and popular Landmarks to visit. Updates every day!',
    image: img2,
  },
  {
    title: 'Personalised Travel Plans',
    text: 'Forget one-size-fits-all itineraries! Your AI concierge Alfred will prepare customised itinerary, considering location, weather, distance, preference and budget. ',
    image: img3,
  },
  {
    title: 'AI-Driven City Exploration ',
    text: 'Uncover the best of every city with intelligent insights, from must-see landmarks to secret spots only locals know. Any questions regarding landmarks? Alfred is ready to answer anytime!',
    image: img4,
  },
];

export const Section4 = () => {
  return (
    <Section4Wrapper>
      <Main>
        <Div $mb='130px'>
          <H2 center mb='30' color={colors.primary}>
            All-in-one solution
          </H2>
          <Div $flex $center>
            <P1 maxWidth='900px' center mb='32' color={colors.white}>
              The future of the internet isn’t in endless scrolling and
              searching—it’s in giving commands and receiving instant results.
              Travelution is an AI-powered, all-in-one travel solution designed
              to replace multiple apps with a single, intelligent platform that
              handles everything a traveler needs.
            </P1>
          </Div>
        </Div>
      </Main>

      <Section4Wrapper2>
        <Swiper
          className='mySwiper'
          loop={true}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          {slides.map(({ title, text, image }) => (
            <SwiperSlide>
              <Main>
                <Div $width='100%' $flex $alignCenter $gap='50px' $columnSM>
                  <Div $width='50%' $widthSM='100%'>
                    <H2 mb='30' right centerSM color={lightTheme.primary}>
                      {title}
                    </H2>
                    <P1 right centerSM color={lightTheme.white}>
                      {text}
                    </P1>
                  </Div>
                  <Div $width='50%' $widthSM='100%'>
                    <Img src={image} width='100%' alt={title} />
                  </Div>
                </Div>
              </Main>
            </SwiperSlide>
          ))}
        </Swiper>
      </Section4Wrapper2>

      <Main>
        <Div $mt='130px'>
          <H2 center mb='30' color={colors.primary}>
            Introducing MyLife points <br /> Pay & Save!
          </H2>
          <Div $flex $center>
            <P1 maxWidth='900px' center mb='32' color={colors.white}>
              With other services, you pay for a subscription and keep
              spending—but with Travelution, you pay for access and save money!
              Every subscription grants you MyLife Points, which you can use to
              discount attractions, stays, and more.
            </P1>
          </Div>
        </Div>
      </Main>
    </Section4Wrapper>
  );
};
